<template>
  <vx-card>
    <h3>Feedback</h3>

    <div class="mt-4">
      <vs-input
        class="w-full mt-4"
        label="Title"
        v-model="title"
        v-validate="'required'"
        name="title"
      />
      <span class="text-danger text-sm" v-show="errors.has('title')">{{
        errors.first('title')
      }}</span>
    </div>

    <div class="mt-4">
      <div class="o-input-score">
        <label class="vs-input--label">Point</label>
        <vs-input-number
          color="success"
          v-model="point"
          min="0"
          v-validate="'required'"
          name="point"
        />
      </div>
      <span class="text-danger text-sm" v-show="errors.has('point')">
        {{ errors.first('point') }}
      </span>
    </div>

    <!-- <div class="mt-4">
      <label class="vs-input--label">Type</label>
      <div class="mt-2">
        <vs-radio
          class="mr-5"
          color="success"
          v-model="type"
          vs-value="default"
        >
          Default
        </vs-radio>
        <vs-radio color="success" v-model="type" vs-value="question">
          Question
        </vs-radio>
      </div>
    </div> -->

    <div class="mt-3">
      <label class="vs-input--label">Description</label>
      <quill-editor
        name="description"
        v-model="desc"
        v-validate="'required'"
      ></quill-editor>
      <span class="text-danger text-sm" v-if="errors.has('description')">
        {{ errors.first('description') }}
      </span>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" :loading="loading" @click="onSubmit">
            Save
          </vs-button>
          <vs-button
            class="ml-4 mt-2"
            type="border"
            color="success"
            to="/section/create"
          >
            Cancel
          </vs-button>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default {
  data() {
    return {
      title: '',
      point: 0,
      desc: '',
      type: 'default',
      loading: false,
    }
  },

  components: {
    quillEditor,
  },

  methods: {
    onSubmit() {
      this.loading = true
      let body = {
        title: this.title,
        point: this.point,
        banner: this.banner,
        desc: this.desc,
        type: this.type,
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          this.$store
            .dispatch('sections/createFeedback', body)
            .then(() => {
              this.isResetForm()
              this.isAlertSuccess()
            })
            .catch(err => {
              this.isAlertFailed(err)
            })
        }

        this.loading = false
      })
    },

    isAlertSuccess() {
      let color = 'success'
      let title = 'Success'
      let text = 'Success add track'
      this.showNotif(color, title, text)
    },

    isAlertFailed(err) {
      let color = 'danger'
      let title = 'Failed'
      let text = err.message
      this.showNotif(color, title, text)
    },

    isResetForm() {
      this.title = ''
      this.point = 0
      this.desc = ''
      this.$validator.reset()
    },

    showNotif(color, title, text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text,
      })
      this.$vs.loading.close()
      this.loading = false
    },
  },
}
</script>
